import { useEffect, useRef } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useAtomValue } from 'jotai';

import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useSnackbar } from '@/hooks/useSnackbar';
import { RoutePath } from '@/routes/RoutePath';

import { allFacilitiesIntentAtom } from './useScreenerFacilityView';

export const useWarnOnLeavingAllFacilitiesSupportedRoute = ({
  pathname,
  isInAllFacilitiesView
}: {
  pathname: string;
  isInAllFacilitiesView: boolean;
}) => {
  const { showSnackbar } = useSnackbar();
  const intent = useAtomValue(allFacilitiesIntentAtom);
  const { isLoading: isCurrentUserLoading } = useCurrentUser();
  const hasWarnedRef = useRef(false);

  const isOnSingleLeadView = pathname.startsWith(
    `${RoutePath.CRMScreenerAllLeads}/`
  );

  const shouldWarn =
    !isCurrentUserLoading &&
    !!intent &&
    !isInAllFacilitiesView &&
    !isOnSingleLeadView;

  useEffect(() => {
    if (shouldWarn && !hasWarnedRef.current) {
      hasWarnedRef.current = true;
      showSnackbar({
        AlertProps: {
          icon: (
            <ErrorOutlineIcon
              sx={{ color: 'warning' }}
              className="MuiAlert-icon"
            />
          )
        },
        severity: 'warning',
        message:
          'All Facilities view is not enabled for this page, your last viewed facility has been selected.',
        NotistackOptions: {
          key: 'leaving-all-facilities-route-warning',
          preventDuplicate: true,
          autoHideDuration: 1500
        }
      });
    } else if (!shouldWarn) {
      hasWarnedRef.current = false;
    }
  }, [shouldWarn, showSnackbar]);
};
